import http from "@seims/shared/src/services/HttpService";
import moment from "moment";

var endpoint = `/system/nysprogramme`;
const headers = {};

const getProgrammeList = async () => {
  const response = await http.get(`${endpoint}/list`);
  return response;
};

const getProgrammeByFinYear = async (selectedDate) => {
  const response = await http.get(`${endpoint}/financialyear?endDate=${selectedDate}`);
  return response;
};

const createNYSProgramme = async (nysProgrammeData) => {
  const response = await http.post(`${endpoint}/create`,nysProgrammeData,
    { headers: headers }
  );
  return response;
};

const updateNYSProgramme = async (nysProgrammeData) => {
  
  const response = http.put(`${endpoint}/update`,nysProgrammeData,
    { headers: headers }
  );
  return response;
};

const getClosingDate = async (selectedYear) => {
  const endpoint = `system/nysprogramme/financialyear?endDate=${selectedYear}`;
  const response = await http.get(`${endpoint}`);
  return response;
};

export default {
  getClosingDate,
  getProgrammeByFinYear,
  getProgrammeList,
  createNYSProgramme,
  updateNYSProgramme

};